import { useMutation, useApolloClient } from '@apollo/react-hooks';
import { CartIdContext } from '../Cart/CartIdContext';
import { getDecrementQuantityOptimisticResponse } from './cartMutationUtils';
import { useContext } from 'react';
import throwErrorInDev from '../../helpers/throwErrorInDev';
import { useTracker } from '../../analytics/Analytics';
import { trackProductEvent } from '../../analytics/tracking';
import { useCart } from '../Query/CartProvider';
import { unSlugify } from '@jetshop/core/analytics/integrations/unslugify';
import { breadcrumbsWithoutProduct } from '@jetshop/core/analytics/utils/breadcrumbsWithoutProduct';
export default function useDecrementQuantity({ decrementQuantityMutation, cartQuery }) {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to useDecrementQuantity`);
    const track = useTracker();
    const { cart } = useCart(cartQuery);
    const { cartId } = useContext(CartIdContext);
    const client = useApolloClient();
    const [decrementQuantityMutationFn] = useMutation(decrementQuantityMutation, {
        onCompleted: () => localStorage.setItem('cartChange', '1')
    });
    function decrementQuantity({ itemId }) {
        var _a, _b, _c, _d;
        const { product, variant: selectedVariation } = (_a = cart === null || cart === void 0 ? void 0 : cart.items) === null || _a === void 0 ? void 0 : _a.find((item) => item.id === itemId);
        track(trackProductEvent({
            action: 'remove',
            product,
            quantity: 1,
            selectedVariation,
            category: breadcrumbsWithoutProduct((_b = product.primaryRoute) === null || _b === void 0 ? void 0 : _b.breadcrumbs) ||
                unSlugify((_d = (_c = product.canonicalCategory) === null || _c === void 0 ? void 0 : _c.primaryRoute) === null || _d === void 0 ? void 0 : _d.path) ||
                ''
        }));
        return decrementQuantityMutationFn({
            variables: {
                input: {
                    cartId,
                    itemId
                }
            },
            optimisticResponse: {
                decrementItemQuantity: {
                    cart: getDecrementQuantityOptimisticResponse({
                        itemId,
                        client,
                        cartId,
                        cartQuery
                    }),
                    __typename: 'CartMutation'
                }
            }
        });
    }
    return { decrementQuantity };
}
//# sourceMappingURL=useDecrementQuantity.js.map